import { Avatar, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { signOut } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import avatarF from '../../Assets/Images//profile__image.png'
import avatarH from '../../Assets/Images/avatar-h.svg'
import StepperStore from '../../LocalForage/StepperStore';
import Teachr from '../../Objects/models/Teachr';
import TeachrRepository from '../../Repositories/TeachrRepository';
import ApiService from '../../Services/ApiService';
import { auth } from '../../Services/FirebaseService';
import Messages from '../utils/Messages';
import SearchBar from './SearchBar';
import TeachrContactRepository from '../../Repositories/TeachrContactRepository';
import NoteForTeachrRepository from '../../Repositories/NoteForTeachrRepository';
import Swal from 'sweetalert2';
import Teachr_Repository from '../../Repositories/Teachr_Repository';

const Navbar = (props: any) => {
    const Swal = require("sweetalert2");
    let timerInterval: any;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate()
    const [user, loading] = useAuthState(auth)
    const [name, setName] = useState('')
    const [teachr, setTeachr] = useState<Teachr>()
    // const [note, setNote] = useState<any>()
    useEffect(() => {
        if (loading) {
        } else {
            if (user) {
                TeachrRepository.getCurrentTeachr().then((response) => {
                    setTeachr(response)
                    if (response.isValidated) {
                        setName(response.firstName + " " + response.lastName)
                        if (!response.isAE || !response.RCS) {
                            navigate('/teachr/profile')
                        }
                    } else {
                        StepperStore.setItem("currentStep" + user?.uid, 4).then(() => navigate('/teachr/register/next'))
                    }

                }).catch(() => {
                    logout()
                })
            } else {
                logout()
            }
        }
    }, [user, loading])
    useEffect(() => {
        TeachrRepository.getCurrentTeachr().then((teachr) => {
            if (teachr.id) {       
                NoteForTeachrRepository.fetchInfoByTeachr(teachr.id).then((note:any) => {
                    if (note?.isShow === false) {
                        Swal.fire({
                            icon: "Warning",
                            title: note?.title,
                            text: note?.description,
                            // timer: 8000,
                            willClose: () => {
                                clearInterval(timerInterval);
                                if (teachr.id) {
                                    Teachr_Repository.isOkByTeachr(teachr.id)
                                }
                            },
                        });
                    
                    }
                })
            }

        })
    }, [])
    const logout = () => {
        signOut(auth).then(() => {
            ApiService.disableAuth()
            navigate("/")
        })

    }
    
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [open, setOpen] = useState(false)
    const handleListItemButtonClick = (
        index: number, link: string
    ) => {
        navigate(link)
        setSelectedIndex(index)
    };
    useEffect(() => {
        if (props.index) {
            setSelectedIndex(props.index)
        }
    }, [props])
    const getProfileImage = () => {
        if (teachr) {
            
            
            if (!teachr.profilePicture) {
                if (teachr.sex === 'MAN') {
                    return (<img className='w-full h-full' src={avatarH} alt="profile" />)
                }
                return (<img className='w-full h-full' src={avatarF} alt="profile" />)
            } else {
                return (<img className='w-full' src={teachr.profilePicture.contentUrl!} alt="profile" />)
            }
        }
    }
    const profileItem = () => {
        return (
            <div className=''>
                <div className='flex items-center gap-4'  >
                    <IconButton
                        className='h-full p-1'
                        onClick={handleClick}
                        aria-controls={openMenu ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                    >

                        <Avatar>{getProfileImage()}</Avatar>
                    </IconButton>
                    <span className='capitalize cursor-default'>{name}</span>
                    <IconButton
                        className='w-8 h-8 rounded-full'
                        onClick={handleClick}
                        aria-controls={openMenu ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                    >
                        <div className={openMenu ? 'rotate-180' : 'rotate-0'}>
                            <svg width="23" height="10" viewBox="0 0 23 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 9L21 1H2L11.5 9Z" fill="#0054A3" stroke="#0054A3" />
                            </svg>
                        </div>
                    </IconButton>

                </div>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={openMenu}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 3px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&:before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem className='font-extrabold font-nunito hover:bg-first hover:text-white text-first hover:fill-white last:fill-first' onClick={() => navigate('/teachr/profile')}>

                        <Avatar>{getProfileImage()}</Avatar> Profil
                    </MenuItem>
                    <MenuItem className='font-extrabold font-nunito hover:bg-first hover:text-white text-first hover:fill-white last:fill-first fill-first' onClick={() => navigate('/teachr/cours')}>
                        <ListItemIcon>
                            <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.1872 13.8603L16.1247 12.7979C15.8435 12.5166 15.4061 12.5166 15.1248 12.7979L15.0311 12.8916L13.4375 11.2981C15.2811 8.61086 15 4.89248 12.5939 2.48636C9.90652 -0.232269 5.5318 -0.232269 2.81351 2.48636C0.0950393 5.20483 0.0950393 9.57948 2.81351 12.2981C5.2196 14.7042 8.90658 14.9854 11.6252 13.1418L13.2188 14.7353L13.125 14.8291C12.8438 15.1103 12.8438 15.5477 13.125 15.829L16.9372 19.6412L19.9369 16.6415L17.1872 13.8603ZM11.2504 10.9231C11.2191 10.9543 11.1566 11.0168 11.1254 11.0481V9.98552C11.1254 9.11063 10.4067 8.36072 9.50056 8.36072H5.93829C5.0634 8.36072 4.31349 9.07937 4.31349 9.98552V11.0167C4.28224 10.9854 4.21973 10.9542 4.18848 10.8917C2.25117 8.95437 2.25117 5.79829 4.18848 3.86099C6.15704 1.89242 9.31289 1.92368 11.2502 3.86099C13.2188 5.82955 13.1563 8.9854 11.2502 10.9231H11.2504Z" />
                                <path d="M20.3747 17.0788L17.4062 20.0472C17.7813 20.2973 18.2186 20.4535 18.6562 20.4535C19.1873 20.4535 19.7499 20.2347 20.1561 19.8286C20.9059 19.0786 20.9684 17.9224 20.3747 17.0787L20.3747 17.0788Z" />
                                <path d="M7.71931 4.04846C6.7194 4.04846 5.93823 4.86085 5.93823 5.82954C5.93823 6.82945 6.75062 7.61061 7.71931 7.61061C8.71922 7.61061 9.50038 6.79823 9.50038 5.82954C9.53163 4.82963 8.71922 4.04846 7.71931 4.04846Z" />
                            </svg>

                        </ListItemIcon>
                        Trouver de nouveaux élèves
                    </MenuItem>
                    <MenuItem className='font-extrabold font-nunito hover:bg-first hover:text-white text-first hover:fill-white last:fill-first fill-first' onClick={() => navigate('/teachr/dashboard/setup')}>
                        <ListItemIcon>
                            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5762 10.774C14.6627 11.2161 15.4639 13.0296 15.4639 15.2H4.53589C4.53589 13.0294 5.33712 11.216 8.4236 10.774C8.76769 11.3298 9.27272 11.6587 9.99983 11.6587C10.7269 11.6587 11.232 11.3299 11.5761 10.774H11.5762Z" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4741 4.6449C13.0317 5.24658 13.3727 6.0517 13.3727 6.93664C13.3727 8.79935 11.8626 10.3095 9.99981 10.3095C8.13701 10.3095 6.62695 8.79944 6.62695 6.93664C6.62695 6.0517 6.96792 5.24658 7.5255 4.6449C8.24258 4.73731 9.09067 4.79077 9.99972 4.79077C10.9088 4.79077 11.7569 4.73731 12.474 4.6449H12.4741Z" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4745 3.39832V4.22052C11.7573 4.31293 10.9091 4.36639 9.99993 4.36639C9.09079 4.36639 8.24256 4.31293 7.52539 4.22052V3.39832L9.25308 3.79786C9.7677 3.91683 10.2321 3.91683 10.7467 3.79786L12.4745 3.39832Z" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.4445 2.00136L9.25307 0.889302C9.7677 0.770216 10.2321 0.770216 10.7467 0.889302L15.5553 2.00136C15.6285 2.01832 15.6789 2.08172 15.6789 2.15694C15.6789 2.23216 15.6285 2.29556 15.5553 2.31252L14.5613 2.54243V4.52757L15.0968 5.45515C15.1712 5.58372 15.1274 5.74846 14.9988 5.823C14.8702 5.89745 14.7055 5.85358 14.6309 5.72501L14.5613 5.60436V5.74343C14.5613 5.89242 14.4405 6.01329 14.2914 6.01329C14.1424 6.01329 14.0216 5.89253 14.0216 5.74343V5.60425L13.9519 5.7249C13.8775 5.85347 13.7127 5.89745 13.5841 5.82289C13.4555 5.74845 13.4115 5.58372 13.4861 5.45503L14.0216 4.52746V2.66709L10.7464 3.42446C10.2318 3.54344 9.76739 3.54344 9.25279 3.42446L4.44422 2.3124C4.371 2.29544 4.32056 2.23205 4.32056 2.15682C4.32056 2.08171 4.371 2.01832 4.44433 2.00136L4.4445 2.00136Z" />
                            </svg>

                        </ListItemIcon>
                        Ajouter un élève
                    </MenuItem>
                    <MenuItem className='font-extrabold font-nunito hover:bg-first hover:text-white text-first hover:fill-white last:fill-first fill-first' onClick={() =>  navigate('/teachr/dashboard/declare')}>
                        <ListItemIcon>
                            <svg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1935 5.28567C15.1736 5.20732 15.1105 5.14716 15.0315 5.13042L14.9347 5.11022V3.75642L15.0926 3.62137C15.155 3.56825 15.1812 3.48376 15.1597 3.40475C15.1383 3.32573 15.0731 3.26602 14.9925 3.25151L14.1054 3.09057L14.1057 1.95071L14.1054 1.92716L14.2688 1.78766C14.331 1.73442 14.3573 1.64993 14.3358 1.57103C14.3144 1.49179 14.2492 1.43219 14.1686 1.41757L6.99779 0.123596C6.9421 0.113328 6.88496 0.126051 6.83875 0.158305L1.28218 4.03345C1.17727 4.0916 0.792893 4.35545 0.80015 5.08882C0.808298 5.88513 1.27949 6.24673 1.29969 6.26182C1.30237 6.26394 1.3055 6.26517 1.30829 6.26706C1.31309 6.27041 1.31789 6.27343 1.3228 6.27633C1.32804 6.27934 1.33351 6.28191 1.33909 6.28448C1.344 6.28693 1.34902 6.28894 1.35449 6.29084C1.36052 6.29307 1.36666 6.29463 1.37291 6.29631C1.37648 6.29742 1.37983 6.29887 1.38329 6.29965L1.7114 6.3684C1.65816 6.51316 1.622 6.69463 1.62435 6.92263C1.62836 7.31717 1.746 7.60489 1.86609 7.79675L1.61185 7.97387C1.50627 8.03279 1.12256 8.29707 1.13005 9.02924C1.13808 9.82555 1.60908 10.188 1.6297 10.2022C1.64745 10.2144 1.68294 10.2332 1.71308 10.24L9.23536 11.8183C9.23614 11.8184 9.23692 11.8187 9.23782 11.819L9.50645 11.8753C9.52085 11.8783 9.53558 11.8798 9.54998 11.8798C9.59987 11.8798 9.64886 11.8621 9.68759 11.8291L14.6316 7.60627C14.6932 7.55359 14.7194 7.47056 14.6994 7.39232C14.6792 7.31397 14.6164 7.25382 14.5372 7.23708L14.4489 7.21866V6.07769L15.1256 5.49978C15.1874 5.44698 15.2137 5.36395 15.1937 5.28571L15.1935 5.28567ZM9.18697 6.06178C9.23708 6.06178 9.28596 6.04404 9.32469 6.01089L13.6838 2.28746V3.63569L9.14784 7.49369V6.05763C9.16112 6.06009 9.17406 6.06176 9.18712 6.06176L9.18697 6.06178ZM1.61068 4.47672L8.72269 5.96901V7.40415L1.61068 5.91487V4.47672ZM1.94083 9.85387V8.4167L9.05254 9.90932V11.3465L1.94083 9.85387ZM2.43837 7.74907V6.52107L8.9058 7.87798C8.90658 7.87809 8.90725 7.87843 8.90803 7.87865L9.17667 7.93501C9.19118 7.93803 9.2058 7.93948 9.22019 7.93948C9.27008 7.93948 9.31919 7.92173 9.35792 7.88881L9.47555 7.78814L9.54665 7.80298V9.23958L2.43837 7.74907ZM14.0247 7.56648L9.47923 11.4362L9.47778 9.99825C9.49072 10.0008 9.50389 10.0023 9.51695 10.0023C9.56684 10.0023 9.61583 9.98463 9.65456 9.9516L9.89441 9.7468L10.0004 9.76901C10.0148 9.77202 10.0296 9.77347 10.0438 9.77347C10.094 9.77347 10.1428 9.75573 10.1816 9.7228L14.0247 6.43852L14.0247 7.56648ZM14.5181 5.46068L9.97323 9.32896L9.97166 7.89168C9.98483 7.89413 9.99778 7.8957 10.0107 7.8957C10.0608 7.8957 10.1097 7.87795 10.1485 7.84503L14.5187 4.11188L14.5181 5.46068Z" />
                            </svg>

                        </ListItemIcon>
                        Déclarer un cours
                    </MenuItem>
                    <Divider />
                    <MenuItem className='font-extrabold font-nunito hover:bg-first hover:text-white text-first hover:fill-white last:fill-first fill-first' onClick={() => logout()}>
                        <ListItemIcon className=''>
                            <svg id='icon' className='font-semibold ' xmlns="http://www.w3.org/2000/svg" width="20" height="20" version="1.1" viewBox="0 0 700 700">
                                <path d="m282.3 508.91c13.879 0 25.18 11.301 25.18 25.18 0 13.883-11.301 25.18-25.18 25.18h-100.68c-10.129 0-20.012-2-29.266-5.8789-9.0039-3.707-17.051-9.0859-24.012-15.922-6.918-6.8789-12.422-14.883-16.215-23.805-4.0039-9.2969-6.0039-19.133-6.0039-29.266v-403.32c0-10.215 2-20.094 5.9609-29.391 3.793-9.0039 9.2539-17.09 16.133-24.012 6.9609-6.918 15.008-12.379 24.012-16.172 9.3398-3.9219 19.219-5.9609 29.391-5.9609h100.68c13.879 0 25.18 11.297 25.18 25.176 0 13.926-11.301 25.18-25.18 25.18h-100.68c-13.883 0-25.18 11.297-25.18 25.18v403.32c0 13.508 11.297 24.512 25.18 24.512zm295.8-248.49c6.8359 4.6289 11.211 12.129 11.211 21.969 0 9.9219-4.375 17.383-11.211 22.012l-77.75 77.746c-10.797 10.754-26.969 10.754-37.727 0-10.797-10.797-10.797-26.973 0-37.727l35.02-35.059h-177.88c-16.176 0-26.973-10.758-26.973-26.973 0-16.133 10.797-26.93 26.973-26.93h177.88l-35.02-35.016c-10.797-10.797-10.797-26.973 0-37.77 10.758-10.797 26.93-10.797 37.727 0z" fill-rule="evenodd" />
                            </svg>
                        </ListItemIcon>
                        Se déconnecter
                    </MenuItem>
                </Menu>
            </div>
        )
    }
    return (
        <div className='bg-white'>
            <div>
                <div className='hidden h-20 py-4 lg:block'>
                    <List sx={{
                        color: '#0054A3',
                        fontSize: "20px",
                        fontWeight: 800,
                        padding: 0,
                        gap: 0,
                        '& .Mui-selected': {
                            backgroundColor: "transparent !important",
                            borderBottom: "3px solid #0054A3",
                            padding: 0,
                        },
                        '& .MuiListItem-root': {
                            cursor: "pointer",
                            padding: '0 20px',
                            paddingBottom: 1,
                            display: "block",
                            width: "max-content",
                            fontFamily: 'Nunito',
                        }
                    }}>
                        <div className='flex items-center /justify-around xl:text-xl lg:text-lg md:text-base text-sm  relative'>
                            <div className=' flex pl-4' >
                            <ListItem selected={selectedIndex === 0} onClick={(event) => handleListItemButtonClick(0, '/teachr/dashboard')}>Tableau de bord</ListItem>
                            <ListItem selected={selectedIndex === 1} onClick={(event) => { handleListItemButtonClick(1, '/teachr/dashboard/coursetype') }}>Mes cours</ListItem>
                            <ListItem selected={selectedIndex === 2} onClick={(event) => handleListItemButtonClick(2, '/teachr/dashboard/student')}>Mes élèves</ListItem>
                            </div>
                            <div className=' absolute right-4'>
                                {profileItem()}
                            </div>
                        </div>

                    </List>

                </div>
                <div className="px-4 py-3 md:px-8 h-14 lg:hidden">
                    <div className="flex items-end w-full">
                        <div className="w-full flex justify-between text-end">
                            <p className='text-xl font-extrabold text-first pt-1'>{selectedIndex === 0 ? "Tableau de bord" : selectedIndex === 1 ? "Mes cours" : "Mes élèves"}</p>
                            <IconButton onClick={() => setOpen(!open)} color="primary" aria-label="menu" component="label">
                                <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="1" y1="1" x2="22" y2="1" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                    <line x1="1" y1="7" x2="22" y2="7" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                    <line x1="1" y1="13" x2="22" y2="13" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </IconButton>
                        </div>
                    </div>
                    <Drawer
                        className='relative top-14 lg:hidden'
                        sx={{
                            '& .MuiDrawer-paper': {
                                top: '3.5rem'
                            },
                        }}
                        anchor="top"
                        open={open}
                        elevation={0}
                        hideBackdrop={true}
                    >

                        <div className='w-full px-4 py-4 mx-auto md:px-8'>
                            {/* <SearchBar /> */}
                        </div>
                        <Divider />
                        <List className='text-sm md:text-base' disablePadding sx={{
                            color: '#0054A3',
                            fontWeight: 800,
                            padding: 0,
                            gap: 0,
                            paddingBottom: 4,
                            '& .Mui-selected': {
                                color: '#fff',
                                backgroundColor: "#0054A3 !important",
                            },
                            '& .MuiListItem-root': {
                                cursor: "pointer",
                                display: "block",
                                fontFamily: 'Nunito',
                            }
                        }}>
                            <ListItem selected={selectedIndex === 0} onClick={(event) => handleListItemButtonClick(0, '/teachr/dashboard')}>Tableau de bord</ListItem>
                            <ListItem selected={selectedIndex === 1} onClick={(event) => handleListItemButtonClick(1, '/teachr/dashboard/coursetype')}>Mes cours</ListItem>
                            <ListItem selected={selectedIndex === 2} onClick={(event) => handleListItemButtonClick(2, '/teachr/dashboard/student')}>Mes élèves</ListItem>
                            <Divider />
                            {profileItem()}
                        </List>
                        <Divider />
                    </Drawer>
                </div>
            </div>
            <Messages />
        </div>
    );
};

export default Navbar;